"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurstOfFireAbilityHandler = exports.BurstOfFireActorAbilityFactory = exports.BurstOfFireAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const enums_1 = require("../../core/enums");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const Settings_1 = require("../../Settings");
class BurstOfFireAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BurstOfFire;
        this.__typeName = "BurstOfFire";
    }
}
exports.BurstOfFireAbilityArgs = BurstOfFireAbilityArgs;
let BurstOfFireActorAbilityFactory = class BurstOfFireActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BurstOfFire", "OneEnemies", 0);
    }
};
BurstOfFireActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BurstOfFire")
], BurstOfFireActorAbilityFactory);
exports.BurstOfFireActorAbilityFactory = BurstOfFireActorAbilityFactory;
let BurstOfFireAbilityHandler = class BurstOfFireAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invokerLevel = container.getLevel(ability.invokerId);
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Fire", 45)
            ],
            projectileType: "FireBolt",
            projectilePath: "line",
            onHit(sequence) {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy), "BlueVapor"));
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_2.LinkedEffectsEffectArgs([
                        new core_2.BurningEffectArgs("Focus", 10),
                        new core_2.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.AllDamageResistance, Settings_1.BASE_LEVEL_ADR * invokerLevel)
                    ], true)
                });
            }
        });
    }
};
BurstOfFireAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BurstOfFire)
], BurstOfFireAbilityHandler);
exports.BurstOfFireAbilityHandler = BurstOfFireAbilityHandler;
